import * as Sentry from '@sentry/browser';

import getBrowserInfo from './browser-detection';

const HASH_PATERN = /\/dist\/(\w*)/;
const BROWSER_INFO = getBrowserInfo();

function isLaunchedByAutomatedTests() {
    try {
        return !!window.sessionStorage.getItem('mm_automated_test');
    } catch (e) {
        /* private navigation or exceeded quota reached */
    }

    return false;
}

function removeHashFromStacktrace(stacktrace = {}) {
    const result = { cleanedStacktrace: stacktrace };

    const { frames } = stacktrace;
    if (!Array.isArray(frames) || !frames.length) {
        return result;
    }

    const hashMatch = frames[0].filename.match(HASH_PATERN);
    if (!Array.isArray(hashMatch) || hashMatch.length < 2) {
        return result;
    }

    const cleanedFrames = frames.map(frame => {
        const { filename } = frame;

        if (typeof filename !== 'string') {
            try {
                Sentry.captureException(
                    new Error(
                        `Invalid frame filename: ${filename} (typeof: ${typeof filename})`,
                    ),
                );
            } catch (e) {
                // ignored
            }
            return frame;
        }

        return {
            ...frame,
            filename: filename.replace(`/${hashMatch[1]}`, ''),
        };
    });

    result.hash = hashMatch[1];
    result.cleanedStacktrace.frames = cleanedFrames;

    return result;
}

function enhanceSentryEvent(event) {
    const { exception, stacktrace } = event;

    if (exception) {
        const { values: exceptionValues } = exception;
        if (Array.isArray(exceptionValues)) {
            exceptionValues.forEach((exceptionValue, index) => {
                const { cleanedStacktrace, hash } = removeHashFromStacktrace(
                    exceptionValue.stacktrace,
                );
                event.exception.values[index].stacktrace = cleanedStacktrace;
                event.tags = event.tags || {};
                event.tags.assetsHash = hash;
            });
        }
    }

    if (stacktrace) {
        const { cleanedStacktrace, hash } = removeHashFromStacktrace(
            stacktrace,
        );
        event.stacktrace = cleanedStacktrace;
        event.tags = event.tags || {};
        event.tags.assetsHash = hash;
    }

    return event;
}

if (typeof document !== 'undefined') {
    try {
        const { platform, environment } = document.body.dataset;

        Sentry.init({
            dsn: 'https://112aa499b18f4916a783bc98197a0c27@sentry.io/1194344',
            attachStacktrace: true,
            sendDefaultPii: true,
            whitelistUrls: [/manomano/],
            blacklistUrls: [/iadvize/, /bengal/],
            environment,
            beforeSend: event => {
                const { name, version } = BROWSER_INFO;
                const shouldSendEvent =
                    // because this is fucking Orange's browser
                    !/ Adventurer\//.test(navigator.userAgent) &&
                    // Used browserslist with filter > 0.5% on 06 aug 2019 to get
                    // min versions
                    ((name === 'Chrome' && version > 72) ||
                        (name === 'Edge' && version > 17) ||
                        (name === 'Firefox' && version > 66) ||
                        (name === 'Safari' && version > 12));

                if (!shouldSendEvent) {
                    return undefined;
                }

                return enhanceSentryEvent(event);
            },
        });

        Sentry.configureScope(scope => {
            // User
            const { isLogged, isB2B } =
                (window && window.manomano && window.manomano.user) || {};
            scope.setUser({ isLogged, isB2B });

            // Tags
            scope.setTag('platform', platform);
            scope.setTag(
                'locale',
                window.navigator.userLanguage || window.navigator.language,
            );
            scope.setTag('automatedTests', isLaunchedByAutomatedTests());
        });

        window.Raven = Sentry;
    } catch (e) {
        console.error(`Sentry initialization failed: ${e.toString()}`);
    }
}

export default Sentry;
